import ExpenseItem from "../ExpenseItems";
import "../Styling/Expenses4.css";

function Expenses(exp_Data) {

    const clickHandler = () => {
      console.log("Clicked!!");
    };

  return (
    <div className="expenses5">
      <h1 className="heading">{exp_Data.expenses[4].heading}</h1>
      <div className="expensesMainBody">
        <ExpenseItem
          title={exp_Data.expenses[6].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[0].amount}
          date={exp_Data.expenses[2].date}
        ></ExpenseItem>
        <ExpenseItem
          title={exp_Data.expenses[1].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[1].amount}
          date={exp_Data.expenses[1].date}
        ></ExpenseItem>
        <ExpenseItem
          title={exp_Data.expenses[2].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[2].amount}
          date={exp_Data.expenses[2].date}
        ></ExpenseItem>
        <ExpenseItem
          title={exp_Data.expenses[1].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[1].amount}
          date={exp_Data.expenses[1].date}
        ></ExpenseItem>
        <ExpenseItem
          title={exp_Data.expenses[2].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[2].amount}
          date={exp_Data.expenses[2].date}
        ></ExpenseItem>
        <ExpenseItem
          title={exp_Data.expenses[1].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[1].amount}
          date={exp_Data.expenses[1].date}
        ></ExpenseItem>
        <ExpenseItem
          title={exp_Data.expenses[2].title}
          desc={exp_Data.expenses[1].desc}
          account={exp_Data.expenses[1].account}
          amount={exp_Data.expenses[2].amount}
          date={exp_Data.expenses[2].date}
        ></ExpenseItem>
      </div>
      <div className="endOfContent5">
        <button className="button" onClick={clickHandler}>
          Add New Card
        </button>
      </div>
    </div>
  );
}

export default Expenses;
